import { FC } from 'react';
import { Control } from 'react-hook-form';
import { InitialValues } from '../schema';
import NewBorrowerFormFieldset from '../NewBorrowerFormFieldset';
import { Grid } from '@mui/material';
import InputField from '../../../../hook_form_fields/InputField';

const AdditionalInformationFieldset: FC<{
  control: Control<InitialValues>;
}> = ({ control }) => {
  return (
    <NewBorrowerFormFieldset>
      <Grid container maxWidth="md" spacing={2} marginBottom={2}>
        <Grid item xs={12} sm={12}>
          <InputField
            data-testid="projectNickname"
            control={control}
            name="application.project_nickname"
            label="Give this project a nickname? (Optional)"
            fullWidth
            maxLength={255}
          />
        </Grid>
      </Grid>
    </NewBorrowerFormFieldset>
  );
};

export default AdditionalInformationFieldset;
